import React from 'react';
import { useSelector } from 'react-redux';
import getPersonalisedProduct from 'store/product/selector/getPersonalisedProduct';
import styles from './PersonalisedProductDescription.module.scss';

const PersonalisedProductDescription = () => {
  const product = useSelector(getPersonalisedProduct);
  if (!product?.description) {
    return null;
  }
  return (
    <div className={styles.productDescription}>
      <span dangerouslySetInnerHTML={{ __html: product.description }} />
    </div>
  );
};

export default PersonalisedProductDescription;
